module.exports = __webpack_public_path__ + "static/media/uma_logo.b901c1e2.svg";